import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledWidgetHero = styled.section`
	.hero {
		color: ${CSSVars.white};
		text-align: center;
		background: url(/assets/hero-bg.webp);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center 0%;
		color: ${CSSVars.white};
		padding: 10px 20px 50px;
		position: relative;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 20px 40px 100px;
		}

		.hero-wrapper {
			.platform-img-wrapper {
				transform: translate(50%, -50%) scale(1.8);
				left: -40px;
				bottom: 40px;
				position: absolute;
				opacity: 0.2;

				img {
					min-height: 60px;
					max-width: 600px;
					max-height: 600px;
					object-fit: contain;
					position: relative !important;
				}
			}

			h1 {
				margin: 0 auto;
				max-width: 1100px;
				margin-bottom: 20px;

				font-size: ${CSSVars.fontSize2XL};
				text-align: left;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					text-align: center;
					font-size: ${CSSVars.fontSize3XL};
				}
			}

			h2 {
				font-size: ${CSSVars.fontSizeLG};
				font-weight: 300;
				max-width: 650px;

				margin: 0 auto;
				text-align: left;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					text-align: center;
				}

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}
		}
	}

	.examples-section {
		padding: 100px 40px;
		color: ${CSSVars.black};

		@media (max-width: 1000px) {
			padding: 50px 20px;
		}

		.examples-content-wrapper {
			max-width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			gap: 100px;

			@media (max-width: 1000px) {
				gap: 50px;
			}

			.example {
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 120px;

				@media (max-width: 1440px) {
					gap: 50px;
				}

				@media (max-width: 1200px) {
					flex-direction: column-reverse;
					align-items: center;
				}

				&.ltr {
					flex-direction: row-reverse;

					@media (max-width: 1200px) {
						flex-direction: column-reverse;
						align-items: center;
					}
				}

				&.top-to-bottom {
					flex-direction: column-reverse;
					gap: 50px;
					text-align: left;
					align-items: flex-start;

					.example-image,
					.html {
						width: 100%;
						border-radius: 5px;
						min-height: unset;
					}

					.browser-mock {
						position: relative;
						width: 100%;
						box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
						border-radius: 15px;
						padding-top: 30px;
						min-height: 400px;

						@media screen and (min-width: ${CSSVars.breakpointMD}) {
							min-height: 600px;
						}

						.browser-bar {
							position: absolute;
							background-color: #ededed;
							width: 100%;
							height: 30px;
							top: 0px;
							border-radius: 15px 15px 0px 0px;

							.dots {
								position: absolute;
								left: 20px;
								top: 9px;
								display: flex;
								align-items: center;
								gap: 10px;

								.dot {
									border-radius: 50px;
									width: 12px;
									height: 12px;

									&:nth-child(1) {
										background-color: #ff6059;
									}
									&:nth-child(2) {
										background-color: #ffbd2e;
									}
									&:nth-child(3) {
										background-color: #28ca42;
									}
								}
							}
						}

						.html {
							max-height: 400px;
							min-height: 400px;
							overflow: auto;

							@media screen and (min-width: ${CSSVars.breakpointMD}) {
								max-height: 600px;
								min-height: 600px;
							}
							/* border-radius: 0 0 15px 15px; */
						}
					}
				}

				.example-details {
					h2 {
						margin-bottom: 20px;
						max-width: 880px;

						font-size: ${CSSVars.fontSize2XL};
						@media (max-width: 860px) {
							font-size: ${CSSVars.fontSizeXL};
						}
					}

					p {
						max-width: 1200px;
						font-weight: 300;
						font-size: ${CSSVars.fontSizeLG};
						line-height: 1.5;
						max-width: 930px;

						@media (max-width: 860px) {
							font-size: ${CSSVars.fontSizeMD};
						}
					}

					button {
						margin-top: 20px;
						font-size: ${CSSVars.fontSizeMD};
					}
				}

				.example-image,
				.html {
					min-width: 600px;
					min-height: 450px;
					object-fit: cover;
					border-radius: 5px;

					@media (max-width: 1200px) {
						height: fit-content;
						min-width: unset;
						max-width: unset;
						min-height: fit-content;
						width: 100%;
					}
				}

				.html {
					min-height: unset;
				}
			}
		}
	}
`;
